module.exports = __webpack_public_path__ + "img/middle-guide.633c5166.svg";